<ng-container *ngIf="matIcon; else svgIconDisplay">
  <mat-icon>{{ matIcon }}</mat-icon>
</ng-container>
<ng-template #svgIconDisplay>
  <mat-icon [svgIcon]="svgIcon"></mat-icon>
</ng-template>
